// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media__page--img-btn {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-delay: 150ms;
    transition-duration: 150ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
.media__page--img-btn .media__page--btn {
    display: none
}
.media__page--img-btn:hover .media__page--btn {
    display: block
}
`, "",{"version":3,"sources":["webpack://./src/pages/MediaPageV2/mediaPage.css"],"names":[],"mappings":"AACE;IAAA,+LAA8D;IAA9D,wJAA8D;IAA9D,uBAA8D;IAA9D,0BAA8D;IAA9D;AAA8D;AAG9D;IAAA;AAAa;AAGb;IAAA;AAAY","sourcesContent":[".media__page--img-btn {\n  @apply transform transition duration-150 delay-150 ease-in-out;\n}\n.media__page--img-btn .media__page--btn {\n  @apply hidden;\n}\n.media__page--img-btn:hover .media__page--btn {\n  @apply block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
